import type { FunctionComponent } from "react";

import type { ShowInVariant, SwapCondition } from "scmp-app/components/header/features/styles";
import { useHomepageLogoLinkProps } from "scmp-app/components/header/hooks";

import { Container, StyledLogoLink, StyledScmpLogoText } from "./styles";

export type HeaderFeaturesLogoTextLinkProps = {
  hideOnSwap?: SwapCondition;
  shouldSwap?: boolean;
  showIn?: ShowInVariant;
  variant?: HeaderFeaturesLogoTextLinkVariant;
};

export type HeaderFeaturesLogoTextLinkVariant = "centered" | "default";

export const HeaderFeaturesLogoTextLink: FunctionComponent<HeaderFeaturesLogoTextLinkProps> = ({
  hideOnSwap,
  shouldSwap,
  showIn,
  variant = "default",
}) => {
  const homepageLogoLinkProps = useHomepageLogoLinkProps();

  return (
    <Container
      $hideOnSwap={hideOnSwap}
      $shouldSwap={shouldSwap}
      $showIn={showIn}
      $variant={variant}
    >
      <StyledLogoLink {...homepageLogoLinkProps}>
        <StyledScmpLogoText />
      </StyledLogoLink>
    </Container>
  );
};

HeaderFeaturesLogoTextLink.displayName = "HeaderFeaturesLogoTextLink";
